import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import apiService from '../services/api';

const ProtectedRoute = ({ children, requiredRole }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    // 检查认证状态
    const checkAuth = async () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setAuthenticated(false);
        setLoading(false);
        return;
      }

      try {
        // 从本地存储获取用户信息
        const userStr = localStorage.getItem('user');
        if (userStr) {
          const user = JSON.parse(userStr);
        setUserRole(user.role);
        setAuthenticated(true);

        // 获取最新的用户信息（包括余额）
        // 🔥 后台刷新，不阻塞路由渲染：
        //    余额刷新不影响鉴权结果（角色取自 localStorage），
        //    此前 await 会让每个页面多等一次 auth/me 往返（实测阻塞约650ms）
        apiService.refreshUserData().catch(() => {});
        } else {
          setAuthenticated(false);
        }
      } catch (error) {
        console.error('解析用户信息失败:', error);
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <Box 
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#0a1929'
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  // 如果需要特定角色且用户没有该角色，则重定向到仪表板
  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute; 